import React from 'react';
import { Row, Col } from 'reactstrap';
import application_contants from '../../../contants/application_contants';
import Strip from '../../../customComponents/Strip/Strip';
import { useWindowWidth } from "@react-hook/window-size";
// import LineColor from '../../../customComponents/LineColor/LineColor';
import HeaderTabs from './HackHeaderTabs';


const HackBanner = () => {
    const width = useWindowWidth();

    return (
        <Strip
            id="tst-strip-banner"
            className="strip strip-no-padding px-0"
            containerType="container-fluid"
        >
            <Row className="mx-0">
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="px-0">
                    <div className="position-relative bluebackgroundbox">
                        {/* <img src={width <= application_contants.MOBILE_BREAKPOINT ? application_contants.MOBILEPATH : application_contants.BGPATHIMG} alt="" /> */}
                         <div className="banner-container">
                            <div>
                                <HeaderTabs />
                                <div>
                                    <img src={application_contants.hack4ttslogo} alt="" className="logohack" />
                                    <div className="title-container">
                                    {/* {width <= application_contants.MOBILE_BREAKPOINT ? <p className="p-large jostRegular section-title title-white align-center"><br></br>Voice Tech for All</p>:
                                    <p className="h4-small section-title title-white py-2">Voice Tech for All </p>} */}
                                        {width <= application_contants.MOBILE_BREAKPOINT ?
                                            <h1 className="h2-small section-title title-white pb-2 title">Voice Tech for All: Building Inclusive Speech AI for India</h1>
                                            :
                                            <h1 className="h1-medium section-title title-white pb-2 title">Voice Tech for All: Building Inclusive Speech AI for India</h1>

                                        }
                                    </div>
                                </div>
                                <div className="hack_dots-container pt-2">
                                    <img src={application_contants.CIRCLEPATHIMG} alt="" />
                                </div>
                                <div className="hack_lng-container">
                                    <p className="jostRegular h5-small section-title title-white"> Build inclusive Text To Speech systems with accent and style transfer using the SYSPIN and SPICOR dataset </p>
                                </div>
                                <div className="hack_lng-container">

                                    <p className="jostRegular h5-small section-title title-white"> 
                                        {/* Hindi | Bengali | Marathi | Telugu | Bhojpuri | Kannada | Magadhi | Chhattisgarhi | Maithili | English | Guajarati */}
                                        The SYSPIN dataset a diverse open-source speech corpus, covering 9 languages. It includes high-quality audio clips, transcripts, and metadata essential for building inclusive, robust TTS systems tailored to real-world linguistic diversity.
                                        </p>
                                </div>
                                <br></br>
                                <br></br>
                                <div className="hack_dots-container pt-2">
                                    
                                    <img src={application_contants.LOGOIMG} alt="" className="logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Strip>

    )
};

export default HackBanner;